var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"text-center p-2 footer-copyright"},[_vm._v("© "+_vm._s(_vm.currentYear)+" MMS")]),_c('div',{staticClass:"p-2 footer-supportmail"},[_vm._v("support@mms.se")])])
}
var staticRenderFns = []

export { render, staticRenderFns }